import React from 'react';

function ConversationList({
  conversations = [],
  selectedConversations = [],
  toggleSelectConversation,
  selectAllConversations,
  deselectAllConversations,
  handleBulkDelete,
  handleDeleteConversation,
  loading,
  onViewConversation,
  page,
  totalPages,
  onPageChange
}) {
  return (
    <div>
      <div style={{ marginBottom: 10, display: 'flex', gap: 8 }}>
        <button onClick={selectAllConversations} disabled={conversations.length === 0} className="refresh-btn">Select All</button>
        <button onClick={deselectAllConversations} disabled={selectedConversations.length === 0} className="refresh-btn">Deselect All</button>
        <button onClick={handleBulkDelete} disabled={selectedConversations.length === 0} className="delete-btn">Delete Selected</button>
        <span style={{ marginLeft: 8, color: '#888' }}>{selectedConversations.length} selected</span>
      </div>
      <div className="conversations-list">
        {loading ? (
          <div className="empty-state">Loading...</div>
        ) : conversations.length === 0 ? (
          <div className="empty-state">No conversations found.</div>
        ) : (
          conversations.map(conv => (
            <div key={conv._id} className="conversation-item" style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 40, minWidth: 40 }}>
                <input
                  type="checkbox"
                  checked={selectedConversations.includes(conv._id)}
                  onChange={() => toggleSelectConversation(conv._id)}
                />
              </div>
              <div style={{ flex: 1 }}>
                <div className="conv-header">
                  <span className="conv-date">{new Date(conv.createdAt).toLocaleString()}</span>
                  <span className="conv-count">{conv.messages.length} messages</span>
                </div>
                <div className="conv-preview">
                  {conv.messages.slice(0, 2).map((msg, idx) => (
                    <div key={idx} className={`conv-msg ${msg.role}`}>{msg.content.slice(0, 80)}</div>
                  ))}
                </div>
              </div>
              <div className="conv-details">
                <button className="view-btn" onClick={() => onViewConversation(conv._id)}>
                  View
                </button>
                <button className="delete-btn" onClick={() => handleDeleteConversation(conv._id)}>
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ConversationList; 